module.exports = __webpack_public_path__ + "static/media/screenshot-view-taste-cover.7a3eda71.png";